import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-agenda-block',
  templateUrl: './skeleton-agenda-block.component.html',
  styleUrls: ['./skeleton-agenda-block.component.scss'],
  standalone: false
})
export class SkeletonAgendaBlockComponent {}
